import { useMutation } from '@apollo/client';
import { CREATE_VERSION_MUTATION } from '../operations';

export const useCreateReportVersion = () => {
  const [createReportVersionMutation] = useMutation(CREATE_VERSION_MUTATION);

  return {
    createReportVersion: async (reportId) => {
      try {
        const data = await createReportVersionMutation({ variables: { reportId } });
        return data;
      } catch (error) {
        console.error('Error creating report:', error);
      }
    },
  };
};
